/**
 * @copyright Elmelo Ltd.
 */

import React from 'react'

import {connect} from 'react-redux'
import * as actions from '../../rdx/actions'

/**
 */
class Chat_Settings extends React.PureComponent
{
    /**
     */
    // constructor( props )
    // {
    //     super( props )
    // }

    /**
     */
    render()
    {
        return (
            <div>
                <h1>Chat Settings ...</h1>
            </div>
            )
    }

    /**
     */
    componentDidMount()
    {
    }
}   // class Chat_Settings

/**
 */
const mapStateToProps = (state) =>
{
    return state
}   //

/**
 */
export default connect(mapStateToProps, actions)( Chat_Settings )


